import * as _ from "lodash";
import * as SPIRIT from "../../SPIRIT";

/**
 * 機能権限管理
 */
export class FunctionLockControl {

    static readonly timerContainerId: string = 'pgTimer';


    UserId: number;
    ProjectId: number;
    FunctionCode: string;

    LockInfo: {
        //FunctionLockId: null,
        //FunctionCode: '',
        //ProjectId: null,
        LockUserId: null,
        LockUserName: null,
        LockStartDateTime: null,
    };

    TimeoutMinutes: 0;

    pgTimer: SPIRIT.components.ProgressTimeSpan;
    $timerContainer: JQuery<HTMLElement>;

    public onStart: () => void;
    public onStateChange: (state: 'locked' | 'unlocked' | 'timeout') => void;

    /** */
    protected getInfoURL = '/CommonAPI/GetFunctionLockInfo';
    /** */
    protected lockURL = '/CommonAPI/FunctionLock';
    /** */
    protected unLockURL = '/CommonAPI/FunctionUnLock';


    /***/
    //now: Date;
    get nowMilliseconds() {
        //
        //return this.now.getTime();
        //リアルタイム参照
        return new Date().getTime();
    };

    /***/
    get startDateTime(): Date {
        if (!this.LockInfo?.LockStartDateTime) { return null; }
        return new Date(this.LockInfo.LockStartDateTime);
    };
    /***/
    get startDateMilliseconds(): number {
        //return (SPIRIT.util.date.isDate(this.startDateTime)) ? this.startDateTime.getMilliseconds() : 0;
        return (SPIRIT.util.date.isDate(this.startDateTime)) ? this.startDateTime.getTime() : 0;
    };
    /***/
    get validDateTime(): Date {
        //if (!this.FunctionLockInfo?.LockValidDateTime) { return null; }
        //return new Date(this.FunctionLockInfo.LockValidDateTime);
        var validDateTime = new Date(this.startDateTime);
        validDateTime.setMinutes(validDateTime.getMinutes() + this.TimeoutMinutes);
        return validDateTime;
    };

    /***/
    get validDateMilliseconds(): number {
        //return (SPIRIT.util.date.isDate(this.validDateTime)) ? this.validDateTime.getMilliseconds() : 0;
        return (SPIRIT.util.date.isDate(this.validDateTime)) ? this.validDateTime.getTime() : 0;
    };


    /***/
    get ToTalSecond() {
        //定義をそのまま使用する場合は下記（validDateTimeが仮に存在しないカラムの場合）
        //return this.TimeoutMinutes;
        //開始から終了までの差
        let interval = this.validDateMilliseconds - this.startDateMilliseconds;
        //let cal = Math.floor(Math.abs(interval) / (1000));
        let cal = Math.floor(interval / (1000));
        return (cal < 0) ? 0 : cal;
    }

    /***/
    get ToTalMinutes() {
        //定義をそのまま使用する場合は下記（validDateTimeが仮に存在しないカラムの場合）
        //return this.TimeoutMinutes;
        //開始から終了までの差
        let interval = this.validDateMilliseconds - this.startDateMilliseconds;
        //let cal = Math.floor(Math.abs(interval) / (60 * 1000));
        let cal = Math.floor(interval / (60 * 1000));
        return (cal < 0) ? 0 : cal;
    }

    /**制限時間までの秒を返す*/
    public get LimitMilliSeconds() {
        let interval = this.validDateMilliseconds - this.nowMilliseconds;
        //let cal = Math.floor(Math.abs(interval));
        let cal = Math.floor(interval);
        return (cal < 0) ? 0 : cal;
    }

    /**制限時間までの秒を返す*/
    public get LimitSeconds() {
        let interval = this.validDateMilliseconds - this.nowMilliseconds;
        //let cal = Math.floor(Math.abs(interval) / 1000);
        let cal = Math.floor(interval / 1000);
        return (cal < 0) ? 0 : cal;
    }

    /**制限時間までの分を返す*/
    public get LimitMinutes() {
        let interval = this.validDateMilliseconds - this.nowMilliseconds;
        //let cal = Math.floor(Math.abs(interval) / (60 * 1000));
        let cal = Math.floor(interval / (60 * 1000));
        return (cal < 0) ? 0 : cal;
    }

    /**
     * 
     * @param userId
     * @param functionCode
     * @param projectId　マスタ計はNULL
     * @param timeoutMinutes
     */
    constructor(userId: number, functionCode: string, projectId?: number) {
        this.UserId = userId;
        this.ProjectId = projectId;
        this.FunctionCode = functionCode;
    }

    /***/
    public get IsEffective() {
        //ロック情報がない場合はfalse
        return (_.isNil(this.LockInfo)) ? false : true;
    }

    /***/
    public get IsLocked() {
        //ロック情報がない場合はfalse
        if (!this.IsEffective) return false;
        //return (this.nowMilliseconds < this.validDateMilliseconds) ? true : false;

        //タイマーの判断基準にあわせ、milli秒で無く秒で判定
        //残り秒数判定
        let interval = this.validDateMilliseconds - this.nowMilliseconds;
        let cal = Math.floor(interval / 1000);

        return cal > 0;
    }

    /**自身がロックしているか*/
    public get IsLockedSelf() {
        //ロック情報がない場合はfalse
        if (this.IsLocked) {
            return this.LockInfo.LockUserId === this.UserId;
        }
        return false;
    }

    /**他の人がロックしているか*/
    public get IsLockedOthers() {
        //ロック情報がない場合はfalse
        if (this.IsLocked) {
            return this.LockInfo.LockUserId != this.UserId;
        }
        return false;
    }




    /** 初期化*/
    async initialize() {
        return new Promise((resolve, reject) => {
            //#4085 抽象的な名称に変更
            //this.getFunctionLock().then((source: { FunctionLockInfo, TimeoutMinutes }) => {
            this.getFunctionLock().then((source: { LockInfo, TimeoutMinutes }) => {
                //{ FunctionLockInfo = functionLockInfo, TimeoutMinutes = timeoutMinutes }
                if (source) {
                    //#4085 抽象的な名称に変更
                    //this.LockInfo = source.FunctionLockInfo;
                    this.LockInfo = source.LockInfo;
                    this.TimeoutMinutes = source.TimeoutMinutes;
                }
                resolve();
            });
        });
    }

    /** 起動*/
    async start() {
        return new Promise((resolve, reject) => {
            //タイマー作成
            this.makeTimer();
            if (this.onStart) {
                this.onStart();
            }
            resolve();
        });
    }

    /** 再起動*/
    async reload() {
        return new Promise((resolve, reject) => {
            this.pgTimer?.destroy();
            this.pgTimer = null;

            this.initialize().then(() => {
                return this.start();
            }).then(() => {
                resolve();
            });

        });
    }

    /** */
    destroy() {
        this.pgTimer?.destroy();
        this.pgTimer = null;
        this.LockInfo = null;
        this.TimeoutMinutes = null;
    }

    private makeTimer() {
        //対象がない場合は動きません
        this.$timerContainer = $('#' + FunctionLockControl.timerContainerId);
        if (this.$timerContainer.length > 0) {
            if (this.IsLocked) {
                this.pgTimer?.destroy();

                this.pgTimer = new SPIRIT.components.ProgressTimeSpan('#' + FunctionLockControl.timerContainerId, this.startDateTime, this.validDateTime, { height: 10, width: 150, interval: 1000 });
                this.pgTimer.onTick = this.onTick.bind(this);
                this.pgTimer.onTickedLabel = this.onTickedLabel;
                this.pgTimer.onTimeOut = this.onTimeOutFork.bind(this);

                ////一旦0に
                //this.pgTimer.current = 0;
                this.pgTimer.start();
            }
        }
    }

    /**
     * 
     * @param c
     */
    onTick(second) {

        //他人がロックしている場合は解除監視を行う
        if (this.IsLockedOthers) {
            //都度チェック
            this.checkFunctionLock().then((lockeInfo: { isLocked, isLockedSelf, isLockedOthers }) => {
                //console.log(lockeInfo);
                //console.log('checking.....unlocked');
                //Start時の状態比べる(基本他の人の状態変化を返す)
                if (this.IsLockedOthers) {
                    if (!lockeInfo.isLockedOthers) {
                        //console.log('unlocked!!!!');
                        this.onStateChange?.call(this, 'unlocked');
                    }
                } else {
                    //コッチは基本ない（他人がロックしている場合は解除監視を行ので、起動時にロック掛かってない場合は監視しないので...）
                    if (lockeInfo.isLockedOthers) {
                        this.onStateChange?.call(this, 'locked');
                    }
                }
            });
        }

        return second;
    }

    /**
     * 
     * @param c
     */
    onTickedLabel(second) {
        var daysLeft = Math.floor(second / (24 * 60 * 60));
        var hoursLeft = (Math.floor(second / (60 * 60))) % 24;
        var minitesLeft = (Math.floor(second / 60)) % 60;
        var secondsLeft = Math.floor(second) % 60;
        // 二桁表示
        //var padMinitesLefts= ("0" + minitesLeft).slice(-2);
        //var padSecondsLefts = ("0" + secondsLeft).slice(-2);

        let cap = "";
        if (daysLeft) { cap += daysLeft + "日"; }
        if (hoursLeft) { cap += hoursLeft + "時間"; }
        if (minitesLeft) { cap += minitesLeft + "分"; }
        if (secondsLeft) { cap += secondsLeft + "秒"; }
        if (cap) {
            cap = "残り: " + cap
        }
        return cap || ' ';
    }

    /**
     * 
     * @param c
     */
    onTimeOutFork() {
        //console.log('onTimeOutFork');
        this.onStateChange?.call(this, 'timeout');
    }

    /**
     * FunctionLock情報情報の取得
     */
    protected async getFunctionLock() {
        return new Promise((resolve, reject) => {
            //FunctionCodeの指定がある場合,ロック情報取得しに行く
            if (this.FunctionCode) {
                //var url = '/CommonAPI/GetFunctionLockInfo';
                var url = this.getInfoURL;

                //param
                var data: any = { functionCode: this.FunctionCode, projectId: this.ProjectId };
                SPIRIT.util.getData(url, data).
                    then((source) => {
                        //console.log('----FunctionLock----');
                        //{ FunctionLockInfo = functionLockInfo, TimeoutMinutes = timeoutMinutes }
                        //console.log(source);
                        resolve(source);
                    });
            } else {
                resolve();
            }
        });
    }


    /**
     * 
     * @param functionCode
     * @param projectId
     */
    public async doFunctionLock() {
        return new Promise((resolve, reject) => {
            //TODO 最新の画面データを取得するべきか？
            this.functionLockUnlockReqest(true, this.FunctionCode, this.ProjectId).then((ret: any) => {
                this.reload().then(() => {
                    //if (ret.Data && ret.Data?.Status === 'Error') {
                    //    // '他ユーザ（{0} さん）が編集中のため、ロックできません。'
                    //    SPIRIT.notify.warn(SPIRIT.util.getMessage(SPIRIT.message.MSG_W_00008, [ret.Data?.FunctionLockInfo?.LockUserName]), { position: 'bottom right' });
                    //} else {
                    //    // 'ロックしました。'
                    //    SPIRIT.notify.info(SPIRIT.util.getMessage(SPIRIT.message.MSG_I_00003), { position: 'bottom right' });
                    //}
                    resolve(ret);
                });
            });

        });
    }

    /**
     * 
     * @param functionCode
     * @param projectId
     */
    public async doFunctionUnLock() {
        return new Promise((resolve, reject) => {
            this.functionLockUnlockReqest(false, this.FunctionCode, this.ProjectId).then((ret: any) => {
                this.reload().then(() => {
                    //// ロック解除しました。'
                    //SPIRIT.notify.info(SPIRIT.util.getMessage(SPIRIT.message.MSG_I_00004), { position: 'bottom right' });
                    resolve(ret);
                });
            });
        });
    }

    /**
     * @param functionCode
     * @param projectId
     */
    protected async functionLockUnlockReqest(lock: boolean, functionCode: string, projectId?: number) {
        //let url = lock ? '/CommonAPI/FunctionLock' : '/CommonAPI/FunctionUnLock';
        let url = lock ? this.lockURL : this.unLockURL;

        return new Promise((resolve: any, reject: any) => {
            //FunctionCodeの指定がある場合,ロック情報取得しに行く
            if (this.FunctionCode) {
                SPIRIT.util.ajax({
                    url: url,
                    type: 'GET',
                    data: { functionCode: this.FunctionCode, projectId: projectId },
                }).then((res) => {
                    let ret = JSON.parse(res);
                    resolve(ret);
                }).catch(e => {
                    reject(e);
                });
            }
        });
    }


    /**
     * 最新のロック状態をチェック
     */
    async checkFunctionLock() {
        return new Promise((resolve, reject) => {
            //#4085 抽象的な名称に変更
            //this.getFunctionLock().then((source: { FunctionLockInfo, TimeoutMinutes }) => {
            this.getFunctionLock().then((source: { LockInfo, TimeoutMinutes }) => {
                let lockeInfo =
                {
                    isLocked: false,
                    isLockedSelf: false,
                    isLockedOthers: false
                }
                //{ FunctionLockInfo = functionLockInfo, TimeoutMinutes = timeoutMinutes }
                if (source) {
                    //#4085 抽象的な名称に変更
                    //var LockInfo = source.FunctionLockInfo;
                    var LockInfo = source.LockInfo;
                    var TimeoutMinutes = source.TimeoutMinutes;
                    if (LockInfo && LockInfo?.LockStartDateTime) {
                        var startDateTime = new Date(LockInfo.LockStartDateTime);
                        var validDateTime = new Date(startDateTime);
                        validDateTime.setMinutes(validDateTime.getMinutes() + TimeoutMinutes);
                        //タイマーの判断基準にあわせ、milli秒で無く秒で判定
                        //残り秒数判定
                        let interval = validDateTime.getTime() - Date.now();
                        let cal = Math.floor(interval / 1000);
                        //残りの時間がある場合は
                        lockeInfo.isLocked = cal > 0;

                        if (lockeInfo.isLocked) {
                            if (LockInfo.LockUserId === this.UserId) {
                                lockeInfo.isLockedSelf = true;
                            } else {
                                lockeInfo.isLockedOthers = true;
                            }
                        }
                    }
                }
                resolve(lockeInfo);
            });
        });
    }


    //private nObserveIntervId;
    ///**
    // * 別で通信してロック状態を取得し、監視する（通信を圧迫するなら、やめる）
    // * @deprecated
    // */
    //observe() {
    //    //ハートビート間隔（5秒）
    //    this.nObserveIntervId = setInterval(() => {
    //        this.checkFunctionLock().then((lockeInfo: { isLocked, isLockedSelf, isLockedOthers }) => {
    //            console.log('Heart Beat:' + lockeInfo.isLocked);
    //            console.log(lockeInfo);
    //            if (!lockeInfo.isLocked) {
    //                //ロック解除されたら強制終了
    //            }
    //        });
    //    }, 5000);
    //}

    ///** 
    // * 監視をやめる
    // * @deprecated
    // */
    //observeStop() {
    //    try {
    //        clearInterval(this.nObserveIntervId);
    //    } catch (e) {
    //        //noop
    //    }
    //}


}